import { render, staticRenderFns } from "./Pre-loader.vue?vue&type=template&id=52220ca8&scoped=true&lang=html"
import script from "./Pre-loader.vue?vue&type=script&lang=js"
export * from "./Pre-loader.vue?vue&type=script&lang=js"
import style0 from "./Pre-loader.vue?vue&type=style&index=0&id=52220ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52220ca8",
  null
  
)

export default component.exports